import {
    Button,
    Paper,
    Table,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    makeStyles,
    CircularProgress,
} from "@material-ui/core";
import {
    Add,
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    tableHeader: {
        background: "#111111",
        height: "100%",
        color: "#fbbbd3",
        fontSize: 14,
    },
    button: {
        background: "#111111",
        color: "#fbbbd3",
        justifyContent: "right",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    buttonText: {
        color: "#111111",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    title: {
        color:"#111111",
        marginBottom: 20,
    }
}));

const ForRentCostumesListLoading = () => {
    const classes = useStyles();

    return (
        <>
            <Typography className={classes.title} variant="h4">For Rent Costumes</Typography>
            <div style={{ display: "center", alignItems: "center", marginTop: 10}}>
                <CircularProgress color="inherit" />
            </div>
        </>
    );
};

export default ForRentCostumesListLoading;